import sizes from './sizes';

export default {
  EditCollectionsItemBlankCard: {
    display: 'flex',
    alignItems: props => (props.isModbile ? 'flex-start' : 'center'),
    justifyContent: 'space-evenly',
    padding: '0px 0px 0px 0px',
    margin: props => (props.isMobile ? '15px 0px 0px 0px' : '5px 0px 0px 0px'),
    color: 'var(--text-primary)',
    backgroundColor: 'var(--background-white)',
    fontSize: '1rem',
    transition: 'all .2s',
    textDecoration: 'none',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    width: props => (props.isMobile ? '93%' : '98.53%'),
    height: props => (props.isMobile ? '300px' : '50px'),
    flexDirection: props => (props.isMobile ? 'column' : 'row'),
    '&:hover': {
      boxShadow: '0px 1px 2px 1px rgba(0, 0, 0, 0.1)',
    },
  },
  setNameWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '25%',
    height: '50px',
    padding: '0px 0px 0px 10px',
  },
  setNameWrapperInput: {
    display: 'flex',
    alignItems: 'center',
    height: '50px',
    padding: '0px 0px 0px 0px',
    justifyContent: props => (props.isMobile ? 'center' : 'flex-start'),
    width: props => (props.isMobile ? '90%' : '25%'),
    margin: props => (props.isMobile ? '10px 0px 0px 0px' : '0px 0px 0px 0px'),
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      borderRadius: '2px',
    },
  },
  categoryWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '25%',
    height: '50px',
    padding: '0px 0px 0px 22px',
  },
  categoryWrapperInput: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: props => (props.isMobile ? 'center' : 'flex-start'),
    width: props => (props.isMobile ? '90%' : '25%'),
    margin: props => (props.isMobile ? '0px 0px 0px 0px' : '0px 0px 0px 0px'),
    height: '50px',
    padding: '0px 0px 0px 0px',
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      borderRadius: '2px',
    },
  },
  label: {
    margin: '0px 10px 0px 0px',
  },
  masteryWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '10%',
    height: '50px',
  },
  masteryWrapperInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '50px',
    height: '50px',
  },
  masteryInfo: {
    padding: '0px 0px 0px 8px',
  },
  totalCardsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '10%',
    height: '50px',
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '10%',
    height: '50px',
  },
  iconWrapperEditing: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginTop: props => (props.isMobile ? '20px' : '0px'),
    width: props => (props.isMobile ? '100px' : '10%'),
    height: props => (props.isMobile ? '75px' : '50px'),
  },
  EditDeckListItemIcon: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
  },
  EditCollectionsItemIcon: {
    height: '40px',
    width: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
    border: '1px solid rgba(0, 0, 0, 0.3)',
    borderRadius: '2px',
    '& i': {
      color: 'rgba(0, 0, 0, 0.7)',
    },
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.7)',
    },
  },
  EditCollectionsItemBlankIcon: {
    height: props => (props.isMobile ? '60px' : '40px'),
    width: props => (props.isMobile ? '60px' : '50px'),
    marginTop: props => (props.isMobile ? '10px' : null),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    fontSize: props => (props.isMobile ? '1rem' : '1.5rem'),
    border: '1px solid rgba(0, 0, 0, 0.3)',
    borderRadius: '2px',
    '& i': {
      color: 'rgba(0, 0, 0, 0.3)',
    },
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.7)',
    },
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '50px',
    width: props => (props.isMobile ? null : '10%'),
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    textDecoration: 'none',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 'var(--button-fontSize-primary)',
    fontWeight: '500',
    background: 'var(--button-primary)',
    width: props => (props.isMobile ? '125px' : '80px'),
    height: '30px',
    border: 'none',
    transition: 'all 0.4s ease 0s',
    borderRadius: '5px',
    '&:hover': {
      background: 'var(--button-accept-primary)',
      transition: 'all 0.4s ease 0s',
      cursor: 'pointer',
    },
  },
  buttonCancel: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    textDecoration: 'none',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 'var(--button-fontSize-primary)',
    fontWeight: '500',
    background: 'var(--button-deny-dark)',
    width: '80px',
    height: '30px',
    border: 'none',
    transition: 'all 0.4s ease 0s',
    borderRadius: props => (props.isMobile ? '5px' : '5px'),
    marginRight: props => (props.isMobile ? '5px' : '0px'),
    '&:hover': {
      background: 'var(--button-deny-primary)',
      transition: 'all 0.4s ease 0s',
      cursor: 'pointer',
    },
    [sizes.down('lg')]: {
      width: '80%',
    },
    [sizes.down('md')]: {
      width: '125px',
      height: '35px',
    },
  },
  buttonSave: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    textDecoration: 'none',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 'var(--button-fontSize-primary)',
    fontWeight: '500',
    background: 'var(--button-accept-dark)',
    width: '80px',
    height: '30px',
    marginLeft: props => (props.isMobile ? '5px' : '0px'),
    border: 'none',
    transition: 'all 0.4s ease 0s',
    borderRadius: props => (props.isMobile ? '5px' : '5px'),
    '&:hover': {
      background: 'var(--button-accept-primary)',
      transition: 'all 0.4s ease 0s',
      cursor: 'pointer',
    },
    [sizes.down('lg')]: {
      width: '80%',
    },
    [sizes.down('md')]: {
      width: '125px',
      height: '35px',
    },
  },
  buttonLink: {
    textDecoration: 'none',
  },
  bottomWrapper: {
    width: '100%',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
